import {
    FETCH_VISITS_REQUEST, FETCH_VISITS_SUCCESS, FETCH_VISITS_FAILURE,
    CREATE_VISIT_SUCCESS, UPDATE_VISIT_SUCCESS, DELETE_VISIT_SUCCESS
  } from '../actions/visitActions';
  
  const initialState = {
    visits: [],
    loading: false,
    error: null,
  };
  
  export default function visitReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_VISITS_REQUEST:
        return { ...state, loading: true };
      case FETCH_VISITS_SUCCESS:
        return { ...state, loading: false, visits: {
          data: action.payload.data, // The data array for the current page
          meta: action.payload.meta, // Metadata including page, limit, and total
        }, };
      case FETCH_VISITS_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case CREATE_VISIT_SUCCESS:
        return { ...state, visits: [...state.visits, action.payload] };
      case UPDATE_VISIT_SUCCESS:
        return {
          ...state,
          visits: state.visits.map((visit) =>
            visit.id === action.payload.id ? action.payload : visit
          ),
        };
      case DELETE_VISIT_SUCCESS:
        return {
          ...state,
          visits: state.visits.filter((visit) => visit.id !== action.payload),
        };
      default:
        return state;
    }
  }
  